module.exports = __webpack_public_path__ + "static/media/web.fb475fe2.config";


//////////////////
// WEBPACK FOOTER
// ./src/web.config
// module id = 510
// module chunks = 0